import { useState, useEffect } from 'react';
import { Clock as ClockIcon, CalendarDays } from 'lucide-react';

export function Clock() {
  const [time, setTime] = useState<string>('');
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      
      // Opciones para la hora
      const timeOptions: Intl.DateTimeFormatOptions = {
        timeZone: 'America/Argentina/Buenos_Aires',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      
      // Opciones para la fecha
      const dateOptions: Intl.DateTimeFormatOptions = {
        timeZone: 'America/Argentina/Buenos_Aires',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      };

      setTime(new Intl.DateTimeFormat('es-AR', timeOptions).format(now));
      setDate(new Intl.DateTimeFormat('es-AR', dateOptions).format(now));
    };

    updateClock();
    const interval = setInterval(updateClock, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-3 text-sm text-gray-600 bg-gray-100 px-3 py-1.5 rounded-lg border border-gray-200">
      {/* Sección de Fecha */}
      <div className="flex items-center gap-1.5">
        <CalendarDays size={16} className="text-gray-500" />
        <span className="font-medium">{date}</span>
      </div>
      
      {/* Separador vertical */}
      <div className="w-px h-4 bg-gray-300"></div>

      {/* Sección de Hora */}
      <div className="flex items-center gap-1.5">
        <ClockIcon size={16} className="text-gray-500" />
        <span className="font-mono font-medium">{time}</span>
        <span className="text-[10px] text-gray-400 font-medium">ART</span>
      </div>
    </div>
  );
}